<template>
  <div class="home page-container" >
    
    <div class="banner">
      <!-- left -->
      <div class="medium-up--one-half">
        <img src="../assets/img/banner1.png" alt="">
      </div>
      <!-- right -->
      <div class="medium-up--one-half">
        <img src="../assets/img/banner2.png" alt="">
      </div>
    </div>
    
    <!--category 2 products-->
    <div
      class="classification"
      v-for="(item,index) in customCategories"
      v-model="local=item.Products=='local'"
      data-index="index"
      :key="index"
    >
      <div class="content">
        <div v-if="item.ListViewType!=='middle-image' && item.Products.length>0" class="padding">
          <div class="category2Title">
            <h2 v-if='$i18n.locale=="en"'>{{item.Name}}</h2>
            <h2 v-if='$i18n.locale=="ch"'>{{item.Description}}</h2>
            <div class="readMore mobile-hide" @click="goToCategory2(item)">
              <h2>{{ $t('readMore')}}</h2>
              <img class="readMoreIcon" src="../assets/img/arrow.png" alt="arrow">
            </div>
          </div>
          <swiper :options="cat2Swiper" :ref="`mySwiper${index}`">
            <swiper-slide v-for="(p, index) in item.Products" :key="index" v-if="!p.IsStopSale">
              <productCard
                v-if='$i18n.locale=="en"'
                v-bind:img="p.Thumbnail"
                v-bind:link="p.link"
                v-bind:name="p.Name"
                v-bind:isPromotion="p.IsPromotion"
                v-bind:price="p.Price"
                v-bind:item="p"
                v-bind:quantity="p.Quantity"
                v-bind:key="index"
              ></productCard>
              <productCard
                v-if='$i18n.locale=="ch"'
                v-bind:img="p.Thumbnail"
                v-bind:link="p.link"
                v-bind:name="p.Description"
                v-bind:isPromotion="p.IsPromotion"
                v-bind:price="p.Price"
                v-bind:item="p"
                v-bind:quantity="p.Quantity"
                v-bind:key="index"
              ></productCard>
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
        <!-- left -->
        <!-- <div v-if="item.ListViewType=='middle-image' && index=='1'" class="medium-up--one-half" @click="goToCategory2(item)">
          <img :src="item.Image" alt="">
        </div> -->
        <!-- right -->
        <!-- <div v-if="item.ListViewType=='middle-image' && index=='1'" class="medium-up--one-half" @click="goToCategory2(item)">
          <img :src="item.Image" alt="">
        </div> -->
      </div>
    </div>
    <!-- end category 2 products-->
    <!--group 20 products-->
    <div
     class="classification"
     v-for="(item,index) in customGroups"
     v-model="local=item.products=='local'"
     data-index="index"
     :key="index"
   >
     <div class="content">
       <div v-if="item.products.length>0" class="padding">
         <div class="groupTitle">
           <h2 v-if='$i18n.locale=="en"'>{{item.Name}}</h2>
           <h2 v-if='$i18n.locale=="ch"'>{{item.Description}}</h2>
         </div>
         <swiper :options="groupSwiper" :ref="`mySwiper${index}`">
           <swiper-slide v-for="(p, index) in item.products" :key="index" v-if="!p.IsStopSale">
             <productCard
               v-if='$i18n.locale=="en"'
               v-bind:img="p.Thumbnail"
               v-bind:link="p.link"
               v-bind:name="p.Name"
               v-bind:isPromotion="p.IsPromotion"
               v-bind:price="p.Price"
               v-bind:item="p"
               v-bind:quantity="p.Quantity"
               v-bind:key="index"
             ></productCard>
             <productCard
               v-if='$i18n.locale=="ch"'
               v-bind:img="p.Thumbnail"
               v-bind:link="p.link"
               v-bind:name="p.Description"
               v-bind:isPromotion="p.IsPromotion"
               v-bind:price="p.Price"
               v-bind:item="p"
               v-bind:quantity="p.Quantity"
               v-bind:key="index" 
             ></productCard> 
           </swiper-slide>
           <div class="swiper-button-prev" slot="button-prev"></div>
           <div class="swiper-button-next" slot="button-next"></div>
         </swiper>
         <!-- <div class="learnMore mobile-hide" @click="navGoGroup(item.ProductGroup_id)">
           <h2>{{ $t('learnMore')}}</h2>
         </div> -->
       </div>
     </div>
   </div>
   <!-- end group 20 products-->
   
   <!--banner-->
   <div class="banner">
     <swiper :options="bannerSwiper">
       <!-- slides -->
       <swiper-slide v-for="(item,index) in filterBillboard(this.$store.state.billboard.billboardImages, $i18n.locale)" data-index="index" :key="index">
         <div v-if="item.URL">
           <a :href="item.URL"><img class='swiImg' :src='item.Image'/></a>
         </div>
         <div v-else ><img class='swiImg' :src='item.Image'/></div>
       </swiper-slide>
       <div class="swiper-pagination" slot="pagination"></div>
     </swiper>
     <div class="banner-button-prev"></div>
     <div class="banner-button-next"></div>
   </div>
   <!--end banner-->
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import { isUserAuthenticated, flyToElement } from "../store/modules/cart";
import productCard from "./productCard";
import $ from 'jquery';
export default {
  name: "home",
  props: {
    inviteCode: {
      type: String,
    },
  },
  components: {
    productCard,
  },
  data() {
    return {
      category:false,
      dataListsChild:[],

      // swiper api：https://www.swiper.com.cn/api/index.html (https://swiperjs.com/)
      bannerSwiper: {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination'
        },
        simulateTouch: false,
        navigation: {
          nextEl: '.banner-button-next',
          prevEl: '.banner-button-prev',
        },
      },
      cat2Swiper: {
        slidesPerView: 4,
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
        },
        breakpoints: {
          320: {
            slidesPerView: 2,
          },
          //when width >= 480
          480:{
            slidesPerView: 2,
          },
          767: {
            slidesPerView: 2,
          },
          //when width >= 640
          990: {
            slidesPerView: 3,
          },
          1200:{
            slidesPerView: 4,
          },
          1280: {
            slidesPerView: 4,
          }
        }
      },
      groupSwiper: {
        slidesPerView: 4,
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
        },
        breakpoints: {
          320: {
            slidesPerView: 2,
          },
          //when width >= 480
          480:{
            slidesPerView: 2,
          },
          767: {
            slidesPerView: 2,
          },
          //when width >= 640
          990: {
            slidesPerView: 3,
          },
          1200:{
            slidesPerView: 4,
          },
          1280: {
            slidesPerView: 4,
          }
        }
      },
      inCart: null,
      flushBbottom: {
        slidesPerView: 1,
      },
      homeImgLeft: true,
    }
  },
  methods:{
    ...mapActions('cart', ['addProductToCart']),
    ...mapActions('products', ['fetchProductDetails']),
    ...mapMutations('products', ['updateActiveProduct']),
    ...mapMutations('checkout', ['setPricesForCheckout', 'saveTotalPrice', 'saveGrandTotal', 'clearPromoCode', 'clearCard']),
    goToProductDetail(product) {
      this.updateActiveProduct(product.ProductNum);
      this.$router.push({ name: 'productDetails', query: { productNum: product.ProductNum} })
    },
    isOutOfStock(item) {
      console.log(item)
      if(item.IsOverSaleable) {
        return false
      }
      return item.StockLevel > 0 ? false : true
    },
    homeImgCountChange() {
      this.homeImgLeft = !this.homeImgLeft;
      return true;
    },
    goToCollections() {
      this.$router.push('/collections')
    },
    goToCategory2(cat2) {
      if (cat2.Products.length > 0) {
        this.$router.push(`/category2/${cat2.Name.toLowerCase()}`)
      }
    },
    handleAddToCartSuccess(item) {
      this.$store.dispatch('cart/addCart', item)
      .then(() => {
        this.$store.dispatch('cart/getCart');
      });
    },
    handleAddToCartFail() {
      alert('Not enough product in stock');
    },
    findRightElement(item, p) {
      if (item.Product_id === p) {
        return
      }
    },
    filterBillboard(billboard, language) {
      const filterBillboard = billboard.filter(image => {
        return image.Language.toLowerCase() === language;
      });
      return filterBillboard;
    },
    addToCart: function(item, event) {
      if (isUserAuthenticated()) {
        this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item})
        .then(() => {
          flyToElement(event.target, $('.cart-link'));
        })
      } else {
        this.$store.dispatch('cart/addProductToLocalCart', item)
        .then(() => {
          this.$store.dispatch('cart/getCart');
          flyToElement(event.target, $('.cart-link'));
        })
      }
    },
    beforeRouteLeave(to, from, next) {
      if (isUserAuthenticated() && to.name === 'purchase') {
        this.$store.dispatch('cart/getCart')
        .then(() => {
          const cartItems = {};
          cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
          cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
          cartItems.ShippingMethod = "Delivery";
          cartItems.Tip = 0;
          cartItems.TipPercentage = 0;
          cartItems.TotalPrice =  this.$store.state.cart.cartProductsList.TotalPrice;
          cartItems.IsShareCreditUsed = this.IsShareCreditUsed;
          const isUSA = localStorage.getItem('isUSA');
          // if (isUSA === false || isUSA === 'false') {
            cartItems.Delivery = 24;
          // }
          this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
          .then(() => {
            this.saveGrandTotal(this.necessaryCartItems.GrandTotal);
            this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
          })
        })
      }
      this.clearPromoCode();
      this.clearCard();
      next();
    },
  },
  computed: mapState ({
    checkoutWithinRadius: state => state.navbar.checkoutWithinRadius,
    checkoutRadiusChecked: state => state.navbar.checkoutRadiusChecked,
    cartProductsList: state => state.cart.cartProductsList,
    customCategories: state => state.products.customCategories,
    customGroups: state => state.products.customGroups,
    token: state => state.auth.token,
    loggedIn: state => state.auth.loggedIn,
    itemCount: state => state.cart.itemCount,
    necessaryCartItems: state => state.cart.necessaryCartItems,
    cartClicked: state => state.cart.cartClicked,
    itemAdded: state => state.cart.itemAdded,
    allGroups: state => state.navbar.allGroups,
    IsShareCreditUsed: (state) => state.checkout.IsShareCreditUsed,
  }),
  mounted() {
    this.$store.dispatch('billboard/fetchBillboardImages');
    this.$store.dispatch('products/fetchCustomCategories');
    this.$store.dispatch('products/fetchCustomGroups');
    if (this.inviteCode) {
      localStorage.setItem('inviteCodeStore', this.inviteCode);
    }
  },
  watch: {

  },
}
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/home.less";
</style>



// WEBPACK FOOTER //
// src/view/home.vue